import { IPlaylistVideos } from '../interfaces/IPlaylistVideos';

export const PlayListSeminario: IPlaylistVideos[] = [
    {
        title: 'Seminário Alfabetização 360: Acolhimento + Abertura',
        idVideo: 'OQJSoeAVwPw',
        description: '',
    },
    {
        title: 'Seminário Alfabetização 360: Intervenção Literária (IL) + Painel 01',
        idVideo: 'Vm1onKHYZQE',
        description: '',
    },
    {
        title: 'Seminário Alfabetização 360: IL + Painel 02',
        idVideo: '273FclHZLfQ',
        description: '',
    },
    {
        title: 'Seminário Alfabetização 360: IL + Painel 03',
        idVideo: 'bcc2Gc2IuvA',
        description: '',
    },
    {
        title: 'Seminário Alfabetização 360: IL + Painel 04',
        idVideo: 'gaAU8Tpf-KA',
        description: '',
    },
    {
        title: 'Seminário Alfabetização 360: Fechamento',
        idVideo: '_WhgGxDXqk8',
        description: '',
    },
    
];
